import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import SVG from 'react-inlinesvg';
import { checkIsActive, toAbsoluteUrl } from '../../../../_helpers';
import {
  AllPermissions,
  checkUserPermision,
  getParentRoute
} from '../../../../../app/servics/CommonFunctions';
import { getAdminSettings } from '../../../../../app/modules/Admin/AdminActions';
import { FormattedMessage, injectIntl } from 'react-intl';

function AsideMenuList({ layoutProps, auth, settingData }) {
  const { value } = settingData;
  const location = useLocation();
  const [noEnte, setNoEnte] = useState(false);
  const redirectUrl = getParentRoute();

  useEffect(() => {
    getAdminSettings().then((res) => {
      setNoEnte(res.data.noEnte);
    });
  }, []);

  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu && 'menu-item-active'} menu-item-open menu-item-not-hightlighted`
      : '';
  };

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/*begin::1 Level*/}
        <li className={`menu-item ${getMenuItemActive(redirectUrl + 'dashboard', false)}`}>
          <NavLink className="menu-link" to={redirectUrl + 'dashboard'}>
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl('/media/svg/icons/Devices/Display1.svg')} />
            </span>
            <span className="menu-text">
              {' '}
              <FormattedMessage id="SIDEMENU.DASHBOARD" />
            </span>
          </NavLink>
        </li>

        {['User', 'Interpreter'].includes(auth.user.role) ? (
          <li className={`menu-item ${getMenuItemActive(redirectUrl + 'calendar', false)}`}>
            <NavLink className="menu-link" to={redirectUrl + 'calendar'}>
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl('/media/svg/icons/Devices/Calendar.svg')} />
              </span>
              <span className="menu-text">
                {' '}
                <FormattedMessage id="SIDEMENU.CALENDAR" />
              </span>
            </NavLink>
          </li>
        ) : null}

        {/*end::1 Level*/}

        {/*}  <li
          className={`menu-item ${getMenuItemActive(redirectUrl+"user-profile", false)}`}

        >
          <NavLink className="menu-link" to={redirectUrl+"user-profile"}>
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl(
                  "/media/svg/icons/Communication/user.svg"
                )}
              />
            </span>
            <span className="menu-text"> <FormattedMessage id="SIDEMENU.PROFILE" /></span>
          </NavLink>
        </li>*/}

        {checkUserPermision(AllPermissions.VIEWUSERLIST) ? (
          <li className={`menu-item ${getMenuItemActive(redirectUrl + 'activeUsers', false)}`}>
            <NavLink className="menu-link" to={redirectUrl + 'activeUsers'}>
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl('/media/svg/icons/Communication/Group.svg')} />
              </span>
              <span className="menu-text">
                {' '}
                <FormattedMessage id="SIDEMENU.ACTIVEUSERS" />
              </span>
            </NavLink>
          </li>
        ) : null}

        {checkUserPermision(AllPermissions.VIEWUSERLIST) ? (
          <li className={`menu-item ${getMenuItemActive(redirectUrl + 'inactiveUsers', false)}`}>
            <NavLink className="menu-link" to={redirectUrl + 'inactiveUsers'}>
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl('/media/svg/icons/Communication/Group.svg')} />
              </span>
              <span className="menu-text">
                {' '}
                <FormattedMessage id="SIDEMENU.INACTIVEUSERS" />
              </span>
            </NavLink>
          </li>
        ) : null}

        {checkUserPermision(AllPermissions.VIEWINTERPRATORLIST) ? (
          <li className={`menu-item ${getMenuItemActive(redirectUrl + 'interpreterList', false)}`}>
            <NavLink className="menu-link" to={redirectUrl + 'interpreterList'}>
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl('/media/svg/icons/Communication/Group.svg')} />
              </span>
              <span className="menu-text">
                {' '}
                <FormattedMessage id="SIDEMENU.INTERPRETER" />
              </span>
            </NavLink>
          </li>
        ) : null}
        {checkUserPermision(AllPermissions.PENDINGAPPOINTMENT) ? (
          <li className={`menu-item ${getMenuItemActive(redirectUrl + 'pendingreqs', false)}`}>
            <NavLink className="menu-link" to={redirectUrl + 'pendingreqs'}>
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl('/media/svg/icons/Code/Warning-1-circle.svg')} />
              </span>
              <span className="menu-text">
                {' '}
                <FormattedMessage id="SIDEMENU.PENDING_APPOINTMENTS" />
              </span>
            </NavLink>
          </li>
        ) : null}

        {/* calculation list */}
        {checkUserPermision(AllPermissions.CALCULATIONLIST) ? (
          <li className={`menu-item ${getMenuItemActive(redirectUrl + 'calculationList', false)}`}>
            <NavLink className="menu-link" to={redirectUrl + 'calculationList'}>
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl('/media/svg/icons/Devices/Calculator.svg')} />
              </span>
              <span className="menu-text">
                {' '}
                <FormattedMessage id="SIDEMENU.CALCULATION_LIST" />
              </span>
            </NavLink>
          </li>
        ) : null}

        {checkUserPermision(AllPermissions.UPDATEAPPOINTMENTTIME) ? (
          <li
            className={`menu-item ${getMenuItemActive(
              redirectUrl + 'update-appointment-time',
              false
            )}`}
          >
            <NavLink className="menu-link" to={redirectUrl + 'update-appointment-time'}>
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl('/media/svg/icons/Communication/Group.svg')} />
              </span>
              <span className="menu-text">
                {' '}
                <FormattedMessage id="SIDEMENU.UPDATE.APPOINTMENT.TIME" />
              </span>
            </NavLink>
          </li>
        ) : null}

        {checkUserPermision(AllPermissions.SHOWAPPOINTMENTS) ? (
          <li
            className={`menu-item ${getMenuItemActive(
              redirectUrl + 'show-appointments',
              false
            )}`}
          >
            <NavLink className="menu-link" to={redirectUrl + 'show-appointments'}>
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl('/media/svg/icons/Communication/Group.svg')} />
              </span>
              <span className="menu-text">
                {' '}
                <FormattedMessage id="SIDEMENU.SHOW_APPOINTMENTS" />
              </span>
            </NavLink>
          </li>
        ) : null}

        {checkUserPermision(AllPermissions.CHATMESSAGE) ? (
          <li className={`menu-item ${getMenuItemActive(redirectUrl + 'chatMessage', false)}`}>
            <NavLink className="menu-link" to={redirectUrl + 'chatMessage'}>
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl('/media/svg/icons/Communication/Chat1.svg')} />
              </span>
              <span className="menu-text">
                {' '}
                <FormattedMessage id="SIDEMENU.CHAT.MESSAGE" />
              </span>
            </NavLink>
          </li>
        ) : null}

        {auth.user.role === 'Admin' &&
        value &&
        value['chat_admin'] &&
        value['chat_admin'].includes(auth.user.id) ? (
          <li className={`menu-item ${getMenuItemActive(redirectUrl + 'adminChatMessage', false)}`}>
            <NavLink className="menu-link" to={redirectUrl + 'adminChatMessage'}>
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl('/media/svg/icons/Communication/Chat1.svg')} />
              </span>
              <span className="menu-text">
                {' '}
                <FormattedMessage id="SIDEMENU.ADMIN.CHAT.MESSAGE" />
              </span>
            </NavLink>
          </li>
        ) : null}

        {checkUserPermision(AllPermissions.CHATMESSAGEWITHADMIN) ? (
          <li
            className={`menu-item ${getMenuItemActive(
              redirectUrl + 'chatMessageWithAdmin',
              false
            )}`}
          >
            <NavLink className="menu-link" to={redirectUrl + 'chatMessageWithAdmin'}>
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl('/media/svg/icons/Communication/Chat1.svg')} />
              </span>
              <span className="menu-text">
                {' '}
                <FormattedMessage id="SIDEMENU.ADMIN.CHAT.MESSAGE" />
              </span>
            </NavLink>
          </li>
        ) : null}

        {checkUserPermision(AllPermissions.AFFILIATEDSTRUCTURES) && !noEnte ? (
          <li
            className={`menu-item ${getMenuItemActive(
              redirectUrl + 'affiliatedStructures',
              false
            )}`}
          >
            <NavLink className="menu-link" to={redirectUrl + 'affiliatedStructures'}>
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl('/media/svg/icons/Home/Building.svg')} />
              </span>
              <span className="menu-text">
                {' '}
                <FormattedMessage id="SIDEMENU.ADMIN.AFFILIATED.STRUCTURE" />
              </span>
            </NavLink>
          </li>
        ) : null}

        {checkUserPermision(AllPermissions.FAQS) ? (
          <li className={`menu-item ${getMenuItemActive(redirectUrl + 'faqs', false)}`}>
            <NavLink className="menu-link" to={redirectUrl + 'faqs'}>
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl('/media/svg/icons/Communication/Clipboard-check.svg')} />
              </span>
              <span className="menu-text">
                {' '}
                <FormattedMessage id="SIDEMENU.FAQ" />
              </span>
            </NavLink>
          </li>
        ) : null}
        {checkUserPermision(AllPermissions.SUPPORT) ? (
          <li className={`menu-item ${getMenuItemActive(redirectUrl + 'support', false)}`}>
            <NavLink className="menu-link" to={redirectUrl + 'support'}>
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl('/media/svg/icons/Communication/Clipboard-check.svg')} />
              </span>
              <span className="menu-text">
                {' '}
                <FormattedMessage id="SIDEMENU.SUPPORT" />
              </span>
            </NavLink>
          </li>
        ) : null}
        {checkUserPermision(AllPermissions.QUICKGUIDES) ? (
          <li className={`menu-item ${getMenuItemActive(redirectUrl + 'quick-guide', false)}`}>
            <NavLink className="menu-link" to={redirectUrl + 'quick-guide'}>
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl('/media/svg/icons/Files/File.svg')} />
              </span>
              <span className="menu-text">
                {' '}
                <FormattedMessage id="SIDEMENU.QUICKGUIDES" />
              </span>
            </NavLink>
          </li>
        ) : null}
      </ul>

      {/* end::Menu Nav */}
    </>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  settingData: state.settingData
});

export default injectIntl(connect(mapStateToProps)(AsideMenuList));
